var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.value),function(file){return [_c('a',{attrs:{"href":file.full_url,"target":"_blank"}},[_c('app-icon',{attrs:{"name":"external-link"}})],1)]}),_vm._v(" "),(_vm.value.length === 0)?_c('div',[_vm._v("\n        "+_vm._s('-')+"\n    ")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }